import api from "../../utils/apiUser";

export const getDireccionesByCliente = async (clienteId) => {
  const res = await api.get(`/api/clientes_direccion/${clienteId}`);
  return res.data;
};

export const crearDireccion = async (data) => {
  const res = await api.post("/api/clientes_direccion", data);
  return res.data;
};

export const actualizarDireccion = async (id, data) => {
  const res = await api.put(`/api/clientes_direccion/${id}`, data);
  return res.data;
};
